export enum AgentTaskType {
  TRANSFER_IN = "TRANSFER_IN",
  TRANSFER_OUT = "TRANSFER_OUT",
  FEE_CHANGE = "FEE_CHANGE",
  NEW_CLIENT = "NEW_CLIENT",
  JOIN_POLICY = "JOIN_POLICY",
  OTHER = "OTHER",
  JOIN_REJECT = "JOIN_REJECT",
  DEPOSIT_TRACKING = "DEPOSIT_TRACKING",
  WITHDRAWAL = "WITHDRAWAL",
  PATH_CHANGE = "PATH_CHANGE",
  LOAN_TRACKING = "LOAN_TRACKING",
  CONSULTING = "CONSULTING",
  POWER_OF_ATTORNEY = "POWER_OF_ATTORNEY",
  VIEW_POWER_OF_ATTORNEY = "VIEW_POWER_OF_ATTORNEY",
  AGENT_UPDATE = "AGENT_UPDATE",
  LOST_ACCOUNT_TRACKING = "LOST_ACCOUNT_TRACKING",
  AGENT_APPOINTMENT = "AGENT_APPOINTMENT",
  AGENT_CANCELLATION = "AGENT_CANCELLATION",
  FOLLOW_UP = "FOLLOW_UP",
  DOCUMENT_REQUEST = "DOCUMENT_REQUEST",
  COVERAGE_REQUEST = "COVERAGE_REQUEST",
  COVERAGES_RESPONSE = "COVERAGES_RESPONSE",
}

export class AgentPhoneBookBase {
  handler_code: string;
  email?: string | null;
  phone?: string | null;
  notes?: string;
  task_types: AgentTaskType[];
  full_name?: string; // שם מלא
  nickname?: string;  // כינוי

}

export class AgentPhoneBook extends AgentPhoneBookBase {
  id: number;
  created_at?: string;
  updated_at?: string;
}

export class AgentPhoneBookOverride extends AgentPhoneBookBase {
  id: number;
  user_id?: number;
  created_at?: string;
  updated_at?: string;

  static defaultEmpty(handler_code: string = ""): AgentPhoneBookOverride {
    return {
      id: -1,
      user_id: undefined,
      handler_code: handler_code,
      email: null,
      phone: null,
      task_types: [],
      notes: "",
      full_name: undefined,
      nickname: undefined,
    };
  }
}
